import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import {
  ModifierPromptOptionType,
  SharedObject
} from 'src/app/models/pos-manager.model';
import { PosManagerSelectors } from 'src/app/store/pos-manager';

export interface IModifierOptionForm {
  name: string;
  price: string;
  product: SharedObject;
  category: SharedObject;
}

@Component({
  selector: 'pos-add-option',
  templateUrl: './add-option.modal.html',
  styleUrls: ['./add-option.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddOptionModal {
  @ViewSelectSnapshot(PosManagerSelectors.getProducts)
  readonly products: SharedObject[];
  @ViewSelectSnapshot(PosManagerSelectors.getCategories)
  readonly categories: SharedObject[];

  modifierType: ModifierPromptOptionType = ModifierPromptOptionType.Text;
  readonly ModifierPromptOptionType = ModifierPromptOptionType;
  readonly MODIFIER_OPTIONS = [
    { name: 'Text Modifier', value: 'text' },
    { name: 'Menu Category', value: 'category' },
    { name: 'Product', value: 'pos_product' }
  ];

  //Default view is 'text modifier' so we initialize name field as required
  form = this.fb.group({
    name: [null, Validators.required],
    price: [null],
    product: [null],
    category: [null]
  });

  constructor(
    private readonly modalController: ModalController,
    private readonly fb: FormBuilder
  ) {}

  onRadioOptionChange(e) {
    this.modifierType = e.detail.value as ModifierPromptOptionType;

    //When the radio option changes, we need to update the validators
    if (this.modifierType === 'text') {
      this.form.get('name').setValidators([Validators.required]);
      this.form.get('product').clearValidators();
      this.form.get('category').clearValidators();
    } else if (this.modifierType === 'category') {
      this.form.get('name').clearValidators();
      this.form.get('product').clearValidators();
      this.form.get('category').setValidators([Validators.required]);
    } else if (this.modifierType === 'pos_product') {
      this.form.get('name').clearValidators();
      this.form.get('product').setValidators([Validators.required]);
      this.form.get('category').clearValidators();
    }

    //After validator rules are updated, force form fields to update its validity.
    this.form.get('name').updateValueAndValidity();
    this.form.get('product').updateValueAndValidity();
    this.form.get('category').updateValueAndValidity();
  }

  cancel() {
    this.modalController.dismiss();
  }

  submit() {
    this.modalController.dismiss({
      type: this.modifierType,
      form: this.form.getRawValue() as IModifierOptionForm
    });
  }
}
